import { AnimationPlayer } from '@/_components';

export default function PagePreLoader() {
  return (
    <div className="flex h-screen w-screen items-center justify-center overflow-hidden bg-primary-xx-light">
      <AnimationPlayer />
    </div>
  );
}
